import { FormFields } from '../../constant';
import TextField from './TextField';

export const FormFieldsComponent = {
  [FormFields.TEXTFIELD]: TextField
}